import { useApprovalQueue } from "./useApprovalQueue";
import { ApprovalQueueCard } from "./ApprovalQueueCard";

/**
 * PRD Screen 4. Not a react-admin <List> — approval_queue lives in the
 * mentorax schema, unreachable through the public-scoped data provider, so
 * this fetches directly via useApprovalQueue (same pattern as the contact
 * outreach timeline).
 */
export const ApprovalQueueList = () => {
  const { data: items, isPending, isError } = useApprovalQueue();

  return (
    <div className="mt-2 mb-2 flex flex-col gap-4">
      <h1 className="text-xl font-semibold">Approval Queue</h1>
      {isPending && (
        <p className="text-muted-foreground text-sm">Loading…</p>
      )}
      {isError && (
        <p className="text-muted-foreground text-sm italic">
          Couldn't load the approval queue.
        </p>
      )}
      {!isPending && !isError && items?.length === 0 && (
        <p className="text-muted-foreground text-sm italic">
          Nothing waiting on review.
        </p>
      )}
      <div className="flex flex-col gap-3">
        {items?.map((item) => (
          <ApprovalQueueCard key={item.id} item={item} />
        ))}
      </div>
    </div>
  );
};
